import { h, render } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useProduct } from './product-context';
import ProductReviewHighlightItem from './product-review-highlight-item';

import 'swiper/css';

const ProductReviewHighlights = () => {
  const { activeProduct, yotpoApiKey } = useProduct();
  const [productReviews, setProductReviews] = useState([]);
  const swiperOptions = {
    spaceBetween: 10,
  };

  useEffect(async () => {
    let baseUrl = `https://api-cdn.yotpo.com/v1/widget/${yotpoApiKey}/products/${activeProduct.id
      .split('/')
      .pop()}/reviews.json?sort=rating&per_page=3`;

    const response = await fetch(baseUrl);
    const json = await response.json();

    if (json.status.code === 200) {
      setProductReviews(json.response.reviews);
    }
  }, []);

  if (!Boolean(productReviews.length)) return null;

  return (
    <div className="cursor-pointer mt-[30px] product-accordions__single-line border-b-1 border-grey-400 pb-[30px]">
      <Swiper className="!h-auto" {...swiperOptions}>
        {productReviews.map((review) => (
          <SwiperSlide className="!h-auto" key={review.id}>
            <ProductReviewHighlightItem review={review} />
          </SwiperSlide>
        ))}
      </Swiper>
      <a
        href="#yotpoMainWidget"
        className="text-h6 block pt-[20px] pb-[20px] underline lg:pb-[0px]"
      >
        Read All Reviews
      </a>
    </div>
  );
};

export default ProductReviewHighlights;
